import { render, staticRenderFns } from "./FormDeclaration.vue?vue&type=template&id=4c855b76&"
import script from "./FormDeclaration.vue?vue&type=script&lang=js&"
export * from "./FormDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports